var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoUniversity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 951.68,
    height: 84.06,
    viewBox: "0 0 951.68 84.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#2684ff;}.cls-3{fill:#0052cc;}.cls-4{fill:#253858;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 28.54,
    y1: 35.57,
    x2: 11.4,
    y2: 65.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0052cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2684ff"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Atlassian University-blue-rgb") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Blue"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.64,30.56a1.88,1.88,0,0,0-3.2.35L.21,63.36a1.94,1.94,0,0,0,1.74,2.81h22.6a1.87,1.87,0,0,0,1.74-1.07C31.15,55,28.2,39.7,19.64,30.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.55,1A42.81,42.81,0,0,0,29,43.3L39.94,65.1a1.94,1.94,0,0,0,1.74,1.07h22.6A1.94,1.94,0,0,0,66,63.36L34.85,1A1.83,1.83,0,0,0,31.55,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M296.63,27.06c0,8,3.73,14.42,18.31,17.23,8.7,1.82,10.52,3.23,10.52,6.13s-1.82,4.64-8,4.64a44.89,44.89,0,0,1-21.13-5.72V62.44c4.39,2.15,10.19,4.56,21,4.56,15.25,0,21.29-6.79,21.29-16.9m0,0c0-9.53-5.05-14-19.31-17.07-7.87-1.74-9.78-3.48-9.78-6,0-3.15,2.82-4.47,8-4.47,6.3,0,12.51,1.91,18.39,4.56V14.63a41.57,41.57,0,0,0-18-3.73c-14.09,0-21.38,6.13-21.38,16.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "492.5 11.73 492.5 66.17 504.1 66.17 504.1 24.66 508.99 35.68 525.39 66.17 539.98 66.17 539.98 11.73 528.38 11.73 528.38 46.87 523.98 36.67 510.81 11.73 492.5 11.73"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 406.04,
    y: 11.73,
    width: 12.68,
    height: 54.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M391.41,50.1c0-9.53-5.05-14-19.31-17.07-7.87-1.74-9.78-3.48-9.78-6,0-3.15,2.82-4.47,8-4.47,6.3,0,12.51,1.91,18.39,4.56V14.63a41.57,41.57,0,0,0-18-3.73C356.7,10.9,349.4,17,349.4,27.06c0,8,3.73,14.42,18.31,17.23,8.7,1.82,10.52,3.23,10.52,6.13s-1.82,4.64-8,4.64a44.89,44.89,0,0,1-21.13-5.72V62.44c4.39,2.15,10.19,4.56,21,4.56,15.25,0,21.29-6.79,21.29-16.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "198.15 11.73 198.15 66.17 224.21 66.17 228.31 54.41 210.91 54.41 210.91 11.73 198.15 11.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "146.67 11.73 146.67 23.5 160.75 23.5 160.75 66.17 173.51 66.17 173.51 23.5 188.59 23.5 188.59 11.73 146.67 11.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M128.16,11.73H111.44l-19,54.44H107L109.65,57A36,36,0,0,0,130,57l2.69,9.17h14.5ZM119.8,47.19a24.76,24.76,0,0,1-7-1l7-23.77,7,23.77A24.76,24.76,0,0,1,119.8,47.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M269.13,11.73H252.4l-19,54.44h14.5L250.61,57a36,36,0,0,0,20.3,0l2.69,9.17h14.5Zm-8.36,35.46a24.76,24.76,0,0,1-7-1l7-23.77,7,23.77A24.76,24.76,0,0,1,260.77,47.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M464.4,11.73H447.68l-19,54.44h14.5L445.89,57a36,36,0,0,0,20.3,0l2.69,9.17h14.5ZM456,47.19a24.76,24.76,0,0,1-7-1l7-23.77,7,23.77A24.76,24.76,0,0,1,456,47.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M573.29,43.37V7.68h8V43.82c0,9.17,3.56,15.58,13.8,15.58s13.8-6.41,13.8-15.58V7.68h8v35.7c0,14.07-6.41,23.68-21.81,23.68S573.29,57.44,573.29,43.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M668.09,66.16h-7.66V39.28c0-8-3.21-11.57-10.5-11.57-7.12,0-12,4.72-12,13.71V66.16h-7.66V21.65h7.66V29A15.6,15.6,0,0,1,652,20.76c10.24,0,16.11,7,16.11,19.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M682.68,4.56A5,5,0,0,1,688,9.9a5.34,5.34,0,1,1-10.68,0A5,5,0,0,1,682.68,4.56Zm-3.92,17.09h7.66V66.16h-7.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M693,21.65h8l14.42,38,14.33-38h8L720.51,66.16H710.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M765.64,67.05c-16.65,0-23.95-9.61-23.95-23.23,0-13.44,7.48-23.06,21-23.06,13.71,0,19.23,9.52,19.23,23.06v3.47H749.44c1.07,7.57,6,12.46,16.47,12.46a39.45,39.45,0,0,0,13.53-2.4v7C775.79,66.34,770.18,67.05,765.64,67.05ZM749.35,40.7h24.84c-.45-8.28-4.18-13-11.84-13C754.25,27.71,750.15,33,749.35,40.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M798.49,66.16H791V21.65h7.48v7.83c2.58-5.25,7-9,15.76-8.46v7.48c-9.79-1-15.76,2-15.76,11.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M834.8,67.05a34.31,34.31,0,0,1-15.49-3.29v-8.1A34.79,34.79,0,0,0,835.16,60c5.88,0,8.9-2.4,8.9-5.87s-2.58-5.34-11-7.39C823.14,44.35,819,40.53,819,33.22c0-7.74,6-12.46,16.11-12.46A31.62,31.62,0,0,1,849.4,24v7.92c-5.34-2.67-9.7-4.1-14.42-4.1-5.61,0-8.63,2-8.63,5.43,0,3.12,2.14,5.07,10.33,7,9.88,2.4,14.87,6.05,14.87,13.8C851.54,61.44,846.73,67.05,834.8,67.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M864.27,4.56a5,5,0,0,1,5.34,5.34,5.34,5.34,0,1,1-10.68,0A5,5,0,0,1,864.27,4.56Zm-3.92,17.09H868V66.16h-7.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M882.69,21.65V12.22h7.48v9.44H902v7.12H890.17V52.1c0,3.92,2.31,6.59,7,6.59a24.33,24.33,0,0,0,4.81-.62v7.39a18.37,18.37,0,0,1-5.16.71c-9.52,0-14.15-5.61-14.15-13.89V28.77h-7.21V21.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M906.81,21.65H915l14.24,38.1,14.24-38.1h8.19L934.85,64.74c-5,12.73-7.83,19.32-19.14,19.32a20.26,20.26,0,0,1-8.19-1.25V76.22a27.41,27.41,0,0,0,7.74,1.07c6.23,0,9-4.27,12.64-14h-5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUniversity);
export default __webpack_public_path__ + "static/media/logo-university.9895ea0ead7445c1856d326c76d6e2fa.svg";
export { ForwardRef as ReactComponent };